import { useFieldArray, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { DataList } from "@/common/DataList";
import type { GeneralInfoTabFormValues } from "@/entities/general-info-tab-content/model";
import { AnniversaryField } from "./AnniversaryField";

type Props = {
  personId: string;
  isEditMode: boolean;
  handleEditMode: () => void;
  onSubmit: (data: GeneralInfoTabFormValues) => void;
  disabled?: boolean;
};

export const AnniversariesList = ({
  personId,
  isEditMode,
  handleEditMode,
  onSubmit,
  disabled,
}: Props) => {
  const { t } = useTranslation();

  const { control, getValues, trigger } = useFormContext<GeneralInfoTabFormValues>();

  const { fields, append, remove } = useFieldArray({
    control,
    name: "anniversaries",
  });

  const onBlur = async () => {
    const isValid = await trigger("anniversaries");

    if (isValid) {
      const formData = getValues();
      onSubmit(formData);
    }
  };

  const onChange = () => {
    trigger("anniversaries");
  };

  const addHandler = () => {
    if (!isEditMode) {
      handleEditMode();
    }

    setTimeout(() => {
      append({
        personId,
        anniversaryType: "",
        description: "",
        id: undefined,
        anniversary: "",
      });
    }, 0);
  };

  const removeHandler = async (index: number) => {
    remove(index);

    const isValid = await trigger("anniversaries");

    if (isValid) {
      const formData = getValues();
      onSubmit(formData);
    }
  };

  return (
    <DataList
      data={fields.map((item) => ({
        id: item?.id ?? "",
        label: item?.description ?? "",
        value: item?.anniversary ?? "",
      }))}
      onAddClick={addHandler}
      onTrashClick={removeHandler}
      isEdit={isEditMode}
      title={t("contactsPage.generalInfo.anniversaries")}
      editNode={(index) => <AnniversaryField index={index} onBlur={onBlur} onChange={onChange} />}
      disabled={disabled}
    />
  );
};
